import { Injectable, inject } from '@angular/core';
import { BrowserPlatformService } from '../browser-platform/browser-platform.service';

// This interface is optional, showing how you can add strong typings for custom globals.
// Just use "Window" as the type if you don't have custom global stuff
export interface ICustomWindow extends Window {
    __custom_global_stuff: string;
}

@Injectable()
export class WindowRefService {
    private readonly _browser = inject(BrowserPlatformService);

    get nullableWindow(): ICustomWindow | null {
        return this._browser.nativeWindow as ICustomWindow | null;
    }

    get nativeWindow(): ICustomWindow {
        const win = this.nullableWindow;
        if (!win) {
            throw new Error('WindowRefService.nativeWindow used during SSR');
        }
        return win;
    }
}
